// extracted by mini-css-extract-plugin
var _1 = "CloseButton-nf7V9";
var _2 = "CloseIcon-w8qFv";
export { _1 as "CloseButton", _2 as "CloseIcon" }
